import { getResultType } from './utils';
import { GremlinResult, GremlinResultType } from './types';
import { flatten, uniq, without } from 'lodash';
import { FormWrapper } from '@ardoq/forms';
import { Multiselect } from '@ardoq/select';
import type { FieldLabelByName } from 'models/utils/fieldOps';
import { t, type I18nLocale } from '@ardoq/i18n';

const getColumnsFromResult = (result: GremlinResult): string[] => {
  const isComponent = getResultType(result) === GremlinResultType.COMPONENT;
  const isReference = getResultType(result) === GremlinResultType.REFERENCE;
  if (isComponent || isReference) {
    return without(Object.keys(result.properties || []), 'name');
  }

  return [];
};

const collectColumnsFromResults = (results: GremlinResult[]): string[] => {
  return uniq(flatten(results.map(getColumnsFromResult)));
};

type GremlinResultsColumnsSelectProps = {
  onSelectedColumnsChange: (selectedColumns: string[] | null) => void;
  selectedColumns: string[];
  results: GremlinResult[];
  fieldLabelByName: FieldLabelByName;
  i18nLocale: I18nLocale;
};
const GremlinResultsColumnsSelect = ({
  onSelectedColumnsChange,
  selectedColumns,
  results,
  fieldLabelByName,
  i18nLocale,
}: GremlinResultsColumnsSelectProps) => {
  const resultTypes = getResultType(results[0]);

  // for now we are limiting ability to select columns to components, and
  // references only
  if (
    ![GremlinResultType.COMPONENT, GremlinResultType.REFERENCE].includes(
      resultTypes
    )
  )
    return null;

  return (
    <FormWrapper>
      <Multiselect
        label={t(
          i18nLocale,
          'search:gremlinResults.selectColumns',
          'Select columns'
        )}
        options={collectColumnsFromResults(results).map(key => ({
          label: fieldLabelByName[key] || key,
          value: key,
        }))}
        value={selectedColumns}
        onValueChange={onSelectedColumnsChange}
        i18nLocale={i18nLocale}
      />
    </FormWrapper>
  );
};

export { GremlinResultsColumnsSelect };
